import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
const BASE_URL = "https://newalemny.3almny.app/api";

// Async thunk to fetch duty details
export const fetchDutyDetails = createAsyncThunk(
  'dutyDetails/fetchDutyDetails',
  async ({ lessonId, dutyId }, { rejectWithValue }) => {
    try {
      // Get token from localStorage
      const token = localStorage.getItem("token3almny");
      
   
      
      if (!token) {
        throw new Error('غير مصرح لك بالوصول');
      }

      const response = await axios.get(`${BASE_URL}/lessons/lesson_duties/${lessonId}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      
      
      if (response.data.statusCode === 200 && response.data.result && response.data.result.length > 0) {
        // Find the specific duty by ID
        const duty = response.data.result.find(d => d.id == dutyId);
      
        if (duty) {
          return duty;
        } else {
          // If duty not found, return the first duty from the result
          return response.data.result[0];
        }
      } else {
        throw new Error('فشل في جلب بيانات الواجب');
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message || 'حدث خطأ في جلب بيانات الواجب');
    }
  }
);

const dutyDetailsSlice = createSlice({
  name: 'dutyDetails',
  initialState: {
    dutyData: null,
    loading: false,
    error: null
  },
  reducers: {
    clearDutyDetailsError: (state) => {
      state.error = null;
    },
    resetDutyDetails: (state) => {
      state.dutyData = null;
      state.loading = false;
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDutyDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDutyDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.dutyData = action.payload;
        state.error = null;
      })
      .addCase(fetchDutyDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { clearDutyDetailsError, resetDutyDetails } = dutyDetailsSlice.actions;
export default dutyDetailsSlice.reducer; 